export default "__VITE_ASSET__BUmhD65y__"